import script from "./FilterPensions.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterPensions.vue?vue&type=script&setup=true&lang=js"

import "./FilterPensions.vue?vue&type=style&index=0&id=a47c876a&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47c876a"]])

export default __exports__